export const SM_PLUGIN_READY_MESSAGE = 'SM_PLUGIN_READY_MESSAGE';